import { IResourceComponentsProps } from "@pankod/refine-core";
import {
  Edit,
  Form,
  Input,
  Select,
  Switch,
  useForm,
  useSelect,
} from "@pankod/refine-antd";
// import {
//   Edit,
//   Form,
//   Input,
//   IResourceComponentsProps,
//   Select,
//   Switch,
//   useForm,
//   useSelect,
// } from "@pankod/refine";

import { IAssociation, IAssociationMembership } from "../../interfaces";

export const AssociationMembershipEdit: React.FC<
  IResourceComponentsProps
> = () => {
  const { formProps, saveButtonProps, queryResult } =
    useForm<IAssociationMembership>({
      metaData: { populate: ["association", "clients"] },
    });

  const { selectProps } = useSelect<IAssociation>({
    resource: "associations",
    optionLabel: "name",
    optionValue: "id",
    defaultValue: queryResult?.data?.data?.association?.data?.id,
    sort: [{ field: "name", order: "asc" }],
  });

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) => {
          return formProps.onFinish?.({
            ...values,
            association: values.association?.data.id,
          });
        }}
      >
        {/* <Form.Item label="Locale" name="locale">
          <Radio.Group disabled>
            <Radio.Button value="en">English</Radio.Button>
            <Radio.Button value="de">Deutsch</Radio.Button>
          </Radio.Group>
        </Form.Item> */}
        <Form.Item
          wrapperCol={{ span: 8 }}
          label="Association"
          name={["association", "data", "id"]}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...selectProps} />
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 14 }}
          label="Company Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          wrapperCol={{ span: 14 }}
          label="Card"
          name="card"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Unofficial" name="unofficial" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  );
};
